import { render } from "./VideoInputSlider.vue?vue&type=template&id=08be778e"
import script from "./VideoInputSlider.vue?vue&type=script&lang=js"
export * from "./VideoInputSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__